export default __webpack_public_path__ + "static/media/Logo_Small_Dark.aeda5579.svg";